import React from "react";
import { Home, Phone, Banknote, QrCode, CheckCircle2 } from "lucide-react";

const STEPS = ["welcome", "phone", "amount", "qr", "result"];
const ICONS = [Home, Phone, Banknote, QrCode, CheckCircle2];

export const WizardProgressDots = ({ current }) => {
  const idx = STEPS.indexOf(current);
  return (
    <div data-testid="wizard-progress" className="flex items-center justify-center gap-2.5">
      {STEPS.map((s, i) => {
        const Icon = ICONS[i];
        const active = i === idx;
        const passed = i < idx;
        return (
          <div
            key={s}
            className={`flex items-center justify-center rounded-full transition-colors ${
              active
                ? "w-10 h-10 bg-[hsl(var(--primary))] text-white"
                : passed
                ? "w-8 h-8 bg-[hsl(var(--accent))] text-white"
                : "w-8 h-8 bg-muted text-muted-foreground"
            }`}
          >
            <Icon size={active ? 20 : 16} strokeWidth={2.5} />
          </div>
        );
      })}
    </div>
  );
};
